import MerchantSimbartDataScreenApi from '@/api/merchant-simbart-activity-data-screen'
import * as MerchantReportBiApi from '@/api/merchant-report-bi'

const state = {}

const mutations = {}

const actions = {
  /**
   * 数据大屏
   */
  async list({ commit }, params) {
    const result = await MerchantSimbartDataScreenApi.list(params)
    return result
  },
  async detail({ commit }, id) {
    const result = await MerchantSimbartDataScreenApi.detail(id)
    return result
  },
  /**
   * 数据报表 获取省份报名汇总
   * @param {*} param0
   * @param {*} params
   * @returns
   */
  async provinceSummary({ commit }, params) {
    const result = await MerchantReportBiApi.provinceSummary(params)
    return result
  },
  /**
   * 数据报表 - 获取报名汇总
   * @param {*} param0
   * @param {*} params
   * @returns
   */
  async summary({ commit }, params) {
    const result = await MerchantReportBiApi.summary(params)
    return result
  },
  /**
   * 数据报表 - 获取日期报名趋势汇总
   * @param {*} param0
   * @param {*} params
   * @returns
   */
  async timeTrendSummary({ commit }, params) {
    const result = await MerchantReportBiApi.timeTrendSummary(params)
    return result
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/merchant-report.js